import { cn } from 'lib/cn';
import { Card } from 'components/ui';
import { formatMoney } from 'lib/formatters';

/**
 * Top-line earnings figures for the selected channel + month.
 * The "In-store sales" gross figure is shown only on the in-store channel.
 */
export function EarningsSummary({ earnings, showInstoreTotal }) {
  const stats = [
    { label: 'Total', value: earnings.totalAmount, accent: true },
    { label: 'Paid out', value: earnings.paidAmount },
    { label: 'Upcoming', value: earnings.upcomingAmount },
  ];
  if (showInstoreTotal) {
    stats.push({ label: 'In-store sales', value: earnings.instoreSalesTotal });
  }

  return (
    <div
      className={cn(
        'grid gap-4 sm:grid-cols-2',
        showInstoreTotal ? 'lg:grid-cols-4' : 'lg:grid-cols-3',
      )}
    >
      {stats.map((stat) => (
        <Card
          key={stat.label}
          className={stat.accent ? 'border-brand-600 bg-brand-600 text-white' : undefined}
        >
          <p className={cn('text-sm', stat.accent ? 'text-brand-50' : 'text-slate-500')}>
            {stat.label}
          </p>
          <p
            className={cn(
              'mt-1 text-2xl font-semibold',
              stat.accent ? 'text-white' : 'text-slate-900',
            )}
          >
            {formatMoney(stat.value)}
          </p>
        </Card>
      ))}
    </div>
  );
}

export default EarningsSummary;
